import {
  combineReducers
} from 'redux';

import modalReducer from './modalReducer';
import secondModalReducer from './secondModalReducer';
import snackBarReducer from './snackBarReducer';
import loginReducer from './loginReducer';
import GenomicsCustomerExecutiveReducer from '../GenomicsCustomeExecutive-Panel/reducers/GenomicsCustomerExecutiveReducer'
import GenomicsPhaReducer from '../GenomicsPhleboAdmin-Panel/reducers/GenomicsPhaReducer'
import GenomicsSaReducer from '../GenomicsSampleAccessioning-Panel/reducers/GenomicsSampleAccessioningReducer'
import GenomicsAdminReducer from '../GenomicsAdmin-Panel/reducers/GenomicsAdminReducer'
import GenomicsCAReducer from '../GenomicsResearch-Panel/reducers/GenomicsResearchReducer'
import GenomicsLabReducer from '../Genomics/Research/store/reducers'
import GenomReducer from '../GenomTracker-Panel/reducers/index'

const rootReducer = combineReducers({
  modalReducer,
  GenomicsCustomerExecutiveReducer,
  secondModalReducer,
  snackBarReducer,
  loginReducer,
  GenomicsPhaReducer,
  GenomicsSaReducer,
  GenomicsAdminReducer,
  GenomicsCAReducer,
  GenomicsLabReducer,
  GenomReducer,
});

export default rootReducer;